import { generateClient } from 'aws-amplify/api';
import { listTestimonials } from '../graphql/queries'; 
import * as mutations from '../graphql/mutations';

const client = generateClient();

// Fetch all testimonials
export const fetchTestimonials = async () => {
  try {
    const result = await client.graphql({ query: listTestimonials });
    const testimonials = result.data.listTestimonials.items;
    return testimonials;
  } catch (error) {
    console.error('Failed to fetch testimonials:', error);
    throw error;
  }
};

// Add a new testimonial
export const addTestimonial = async (body, name) => {
  try {
    const response = await client.graphql({
      query: mutations.createTestimonial,
      variables: { input: { body, name } }
    });

    if (response.data && response.data.createTestimonial) {
      console.log('Create response:', response.data.createTestimonial);
      alert('Testimonial added successfully');
      return response.data.createTestimonial;
    } else {
      console.error('Failed to add testimonial');
      alert('Failed to add testimonial');
    }
  } catch (error) {
    console.error('Add failed:', error);
    alert('Error during addition');
    throw error;
  }
};

// Delete a testimonial
export const deleteTestimonial = async (id) => {
  try {
    const response = await client.graphql({
      query: mutations.deleteTestimonial,
      variables: { input: { id } }
    });

    if (response.data && response.data.deleteTestimonial) {
      console.log('Delete response:', response.data.deleteTestimonial);
      alert('Testimonial deleted successfully');
    } else {
      console.error('Failed to delete testimonial: No deleteTestimonial data');
      alert('Failed to delete testimonial');
    }
  } catch (error) {
    console.error('Delete failed:', error);
    alert('Error during deletion');
  }
};

// Edit a testimonial
export const editTestimonial = async (id, body, name) => {
  const testimonialDetails = {
    id,
    body,
    name,
  };

  try {
    const response = await client.graphql({
      query: mutations.updateTestimonial,
      variables: { input: testimonialDetails }
    });

    if (response.data && response.data.updateTestimonial) {
      console.log('Edit response:', response.data.updateTestimonial);
      alert('Testimonial updated successfully');
      return response.data.updateTestimonial;
    } else {
      console.error('Failed to update testimonial: No updateTestimonial data');
      alert('Failed to update testimonial');
    }
  } catch (error) {
    console.error('Update failed:', error);
    alert('Error during update');
    throw error;
  }
};
